<template>
  <div class="page" :style="{height: height}" v-loading="loading">
    <div>试题信息</div>
    <div class="info">
      <el-form ref="form"  inline :model="form" label-width="120px">
        <el-form-item label="试题名称">
          <el-input v-model="form.groupName" :disabled="isDisable" class="date-input" size="small"></el-input>
        </el-form-item>
        <el-form-item label="试题类型">
          <el-select v-model="form.type"  :disabled="isDisable" placeholder="请选择活动区域" size="small">
            <el-option label="单选" value="radio"></el-option>
          </el-select>
        </el-form-item>
        <div class="upload">
          <div class="tips">提示：建议首页题目背景图上传尺寸750像素 X 1334像素</div>
          <el-form-item label="首页背景图">
            <el-upload
              :disabled="isDisable"
              class="prizeImg-uploader"
              action=""
              accept="image/gif, image/jpeg, image/png, image/jpeg"
              :show-file-list="false"
              :http-request="(file) =>uploadImg(file, 'homeBackground')"
              >
              <img v-if="form.homeBackground" :src="form.homeBackground" class="prizeImg">
              <i v-else class="el-icon-plus prizeImg-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="题目背景图">
            <el-upload
              :disabled="isDisable"
              class="prizeImg-uploader"
              action=""
              accept="image/gif, image/jpeg, image/png, image/jpeg"
              :show-file-list="false"
              :http-request="(file) =>uploadImg(file, 'questionBackground')"
              >
              <img v-if="form.questionBackground" :src="form.questionBackground" class="prizeImg">
              <i v-else class="el-icon-plus prizeImg-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div>题目详情</div>
    <div class="detail">
      <template v-for="(item,index) in form.questionDTOList">
        <div class="subject" :key="index">
          <div class="title">题目{{index+1}}</div>
          <el-input size="small" autosize placeholder="请输入内容" :disabled="isDisable" v-model="item.questionTitle"></el-input>
          <i class="el-icon-circle-plus-outline el-icon" @click="addSubject"></i>
          <i class="el-icon-remove-outline el-icon el-icon-outline" v-if="form.questionDTOList.length > 1" @click="delSubject(index)"></i>
        </div>
        <div class="subject answer" v-for="(item1,index1) in item.answerDTOList">
          <div class="title">答案 {{index1+1}}</div>
          <el-input size="small"  placeholder="请输入内容" :disabled="isDisable" v-model="item1.answerContext"></el-input>
          <i class="el-icon-circle-plus-outline el-icon" @click="addAnser(item.answerDTOList)"></i>
          <i class="el-icon-remove-outline el-icon el-icon-outline" v-if="item.answerDTOList.length > 1" @click="delAnswer(item.answerDTOList,index1)"></i>
          <el-radio v-model="item1.boolRight" :disabled="isDisable" :label="true" @change="changeRadio($event,item.answerDTOList,index1)">正确答案</el-radio>
        </div>
      </template>
      <div class="footer-botton" v-if="from !== 'see'">
        <el-button type="primary" @click="submit">{{isDisable ? '编辑' : '保存'}}</el-button>
        <el-button type="primary" @click="cancel">取消</el-button>
      </div>
    </div>
   
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  data () {
    return {
      height: '88vh',
      loading: false,
      isDisable: false,
      isFirst: true,
      form: {
        groupName: '',
        type: 'radio',
        homeBackground: 'https://img3.quanyou.com.cn/joy/group1/M00/14/CB/rB4ChWL0ufCARwhpAA1b5TenLOc864.png',
        questionBackground: 'https://img3.quanyou.com.cn/joy/group1/M00/14/D4/rB4ChWL1sLKACl2OABQSmSUdhLw379.png',
        questionGroupId: '',
        delAnswerIdList: [],
        delQuestionIdList: [],
        questionDTOList: [
          {
            isDeleted: '',
            questionGroupId: '',
            questionId: '',
            questionTitle: '',
            sortNo: 1,
            answerDTOList: [
              {
                answerContext: '',
                answerId: '',
                boolRight: true,
                isDeleted: '',
                questionGroupId: '',
                questionId: '',
                sortNo: 1
              }
            ]
          }
        ]
      }
    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    from () {
      return this.$route.query.from
    }
  },
  created () {
    this.height = document.documentElement.clientHeight  - 110 + 'px'
    if (this.id) {
      this.getQuestionGroupById()
    }
    this.isDisable = this.from === 'see'
  },
  methods: {
    getQuestionGroupById () {
      this.$api.question.getQuestionGroupById(this.id)
        .then(res => {
          if (res.success) {
            if (res.data.questionDTOList.length) {
              res.data.questionDTOList.forEach(item => {
                if (item.answerDTOList.length) {
                  item.answerDTOList.forEach(item1 => {
                    item1.boolRight = JSON.parse(item1.boolRight)
                  })
                }
              })
            }
            res.data.delAnswerIdList = []
            res.data.delQuestionIdList = []
            this.form = res.data
          }
        })
    },

    uploadImg (file, field) {
      const isLt2M = file.file.size / 1024 / 1024 < 3
      const a = /\.(jpg|jepg|gif|png|jpeg)$/
      const isType = a.test(file.file.name)
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 3MB!')
        return
      }
      if (!isType) {
        this.$message.error('请上传jpg/png图片!')
        return
      }
      this.loading = true
      this.$api.common.uploadImg(file.file)
        .then(({ data }) => {
          this.form[field] = data[0] && data[0].fileUrl || ''
          this.$refs.form.clearValidate('imgUrl')
        })
        .finally(_ => {
          this.loading = false
        })
    },
    addSubject () {
      if (this.isDisable) return
      const sortNo = this.form.questionDTOList.length + 1
      this.form.questionDTOList.push({
        isDeleted: '',
        questionGroupId: '',
        questionId: '',
        questionTitle: '',
        sortNo: sortNo,
        answerDTOList: [
          {
            answerContext: '',
            answerId: '',
            boolRight: true,
            isDeleted: '',
            questionGroupId: '',
            questionId: '',
            sortNo: 1
          }
        ]
      })
    },
    delSubject (index) {
      if (this.isDisable) return
      let questionId = this.form.questionDTOList[index].questionId
      if (questionId) {
        this.form.delQuestionIdList.push(questionId)
      }
      this.form.questionDTOList.splice(index, 1)
    },
    addAnser (item) {
      if (this.isDisable) return
      if (item.length > 3) {
        this.$message({
          message: '最多只能添加四个答案',
          type: 'warning'
        })
        return
      }
      const sortNo = item.length + 1
      item.push({
        answerContext: '',
        answerId: '',
        boolRight: false,
        isDeleted: '',
        questionGroupId: '',
        questionId: '',
        sortNo: sortNo
      })
    },
    delAnswer (item, index) {
      if (this.isDisable) return
      if (item[index].boolRight) {
        this.$message({
          message: '正确答案不能删除',
          type: 'warning'
        })
        return
      }
      let answerId = item[index].answerId
      if (answerId) {
        this.form.delAnswerIdList.push(answerId)
      }
      item.splice(index, 1)
    },
    changeRadio (e, arr, arrIndex) {
      arr.forEach((item, index) => {
        if (arrIndex !== index) item.boolRight = false
      })
    },
    submit () {
      if (this.isDisable) {
        this.isDisable = false
        return
      }
      if (this.form.groupName && this.isFirst) {
        const isAdopt = this.fieldValidation()
        if (!isAdopt) {
          this.$message({
            message: '请完善试题',
            type: 'warning'
          })
        } else {
          this.loading = true
          this.isFirst = false
          this.$api.question.saveQuestion(this.form)
            .then(res => {
              if (res.success) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$router.go(-1)
              }
            })
            .finally(_ => {
              this.loading = false
              this.isFirst = true
            })
        }
      } else {
        this.$message({
          message: '请输入试题名称',
          type: 'warning'
        })
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    fieldValidation () {
      const fileds = ['isDeleted', 'questionGroupId', 'questionId', 'answerId']
      let isAdopt = true
      function recursion (arr) {
        arr.forEach(item => {
          for (const [key, value] of Object.entries(item)) {
            if (!Array.isArray(value)) {
              if (!fileds.includes(key)) {
                if (value === '') isAdopt = false
              }
            } else {
              recursion(value)
            }
          }
        })
      }
      recursion(this.form.questionDTOList)
      return isAdopt
    },
    keyIndex () {
      return Math.random() * 10000
    }
  },
  filters: {

  }
}
</script>

<style lang="stylus" scoped>
  .page {
    height: 89vh;
    border-radius 5px
    padding 15px 20px
    margin 5px 15px 0
    background: #fff;
    overflow: auto;
    .date-input {
      width 300px !important
    }
    .prizeImg-uploader {
      >>>.el-upload {
        border: 1px dashed  #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      &:hover {
        border-color: #0bb78e;
      }
      .prizeImg-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 110px;
        height: 110px;
        line-height: 100px;
        text-align: center;
      }
      .prizeImg {
        width: 110px;
        height: 110px;
        display: block;
      }
      
    }
    .tips {
      margin 0 0 10px 40px
      font-size 12px
      color #999
    }
   
    .detail {
      width: 100%;
      // height: 50%;
      // overflow: auto;
      .subject {
        display: flex;
        align-items: center;
        margin: 10px;
        .title {
          width: 100px;
        }
        .el-icon {
          font-size: 24px;
          color: #999;
          margin: 0 10px;
        }
        .el-icon-outline {
          margin-left: 0;
        }
      }
      .answer {
        margin: 10px;
        .title {
          width: 150px
        }
      }
    }
    @media (max-height: 768px) {
      .detail {
        height:25%;
      }
    }
    .footer-botton {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      margin-top: 20px
      padding: 10px 0;
    }
  }
</style>
